class Console {
    info = (...params) => ((process.env.NODE_ENV === 'development') || window.debug) && console.info(...params)
    debug = (...params) => ((process.env.NODE_ENV === 'development') || window.debug) && console.debug(...params)
    warn = (...params) => ((process.env.NODE_ENV === 'development') || window.debug) && console.warn(...params)
    error = (...params) => ((process.env.NODE_ENV === 'development') || window.debug) && console.error(...params)
}
export default new Console();